import styled, { css } from 'styled-components';

export const TitleTextContainer = styled.div`
    font-family: "museo sans";
    font-weight: 700;
    font-size: 44px;
    line-height: 52px;
    
    ${props => css`
        color: ${props.color}
    `}




`;